import Favicon from 'react-favicon';

import boxpostIco from '../../assets/img/favicons/boxpost.ico';
import citypostIco from '../../assets/img/favicons/citypost.ico';
import ecologisticIco from '../../assets/img/favicons/ecologistic.ico';
import logistarIco from '../../assets/img/favicons/logistar.ico';
import myboxIco from '../../assets/img/favicons/mybox.ico';
import postexpressIco from '../../assets/img/favicons/postexpress.ico';
import jonexpressIco from '../../assets/img/logos/jonexpress.png';
import koderIco from '../../assets/img/logos/koder-icon.svg';

const favicons = {
  koder: koderIco,
  ecologistic: ecologisticIco,
  ecologistictest: ecologisticIco,
  mybox: myboxIco,
  boxpost: boxpostIco,
  boxposttest: boxpostIco,
  citypost: citypostIco,
  postexpress: postexpressIco,
  logistar: logistarIco,
  jonexpress: jonexpressIco,
};

function FaviconLoader(): JSX.Element {
  const clientName =
    (process.env.REACT_APP_CLIENT_NAME as keyof typeof favicons) ?? 'koder';

  return <Favicon url={favicons[clientName] || koderIco} />;
}

export default FaviconLoader;
